// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject6":"Tables-module--seeLiveProject6--1D2FB","sourceCodeProject6":"Tables-module--sourceCodeProject6--QACFS"};